export const messages = {
  en: {
    mapping: {
      search: {
        title: 'Search Condition',
        domain: 'domain',
        name: 'name',
        mappingKey: 'mappingKey',
        value: 'value',
        remark: 'remark',
        createTime: 'createTime',
        placeholder: 'Please enter mapping name'
      },
      list: {
        title: 'mapping List'
      },
      dialog: {
        addTitle: 'Add Mapping',
        editTitle: 'Edit Mapping',
        delTitle: 'Delete Mapping',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        id: 'id',
        domain: 'domain',
        name: 'name',
        mappingKey: 'mappingKey',
        value: 'value',
        remark: 'remark',
        createTime: 'createTime',
      },
      table: {
        id: 'id',
        domain: 'domain',
        name: 'name',
        mappingKey: 'mappingKey',
        value: 'value',
        remark: 'remark',
        createTime: 'createTime',
      },
      validate: {
        id: 'Please enter id',
        domain: 'Please enter domain',
        name: 'Please enter name',
        mappingKey: 'Please enter mappingKey',
        value: 'Please enter value',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add Mapping success'
      },
      edit: {
        success: 'Edit Mapping success'
      },
      delete: {
        success: 'Delete Mapping success',
        confirm: 'Are you sure to delete this mapping?'
      },
      fetchError: 'Failed to fetch mapping list'
    }
  },
  zh: {
    mapping: {
      search: {
        title: '查询条件',
        domain: '域',
        name: '名称',
        mappingKey: '键',
        value: '值',
        remark: '描述',
        createTime: '创建时间',
        placeholder: '请输入配置中心名称'
      },
      list: {
        title: '配置中心'
      },
      dialog: {
        addTitle: '添加配置中心',
        editTitle: '编辑配置中心',
        delTitle: '删除配置中心',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        id: '编码ID',
        domain: '域',
        name: '名称',
        mappingKey: '键',
        value: '值',
        remark: '描述',
        createTime: '创建时间',
      },
      table: {
        id: '编码ID',
        domain: '域',
        name: '名称',
        mappingKey: '键',
        value: '值',
        remark: '描述',
        createTime: '创建时间',
      },
      validate: {
        id: '请输入编码ID',
        domain: '请输入域',
        name: '请输入名称',
        mappingKey: '请输入键',
        value: '请输入值',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加配置中心成功'
      },
      edit: {
        success: '编辑配置中心成功'
      },
      delete: {
        success: '删除配置中心成功',
        confirm: '确认删除该配置中心吗？'
      },
      fetchError: '获取配置中心列表失败'
    }
  }
}